import md5 from './md5';

export default function(str){
    const arr = Array.from(str).reverse()
    const ns = arr.join('');
    return md5(ns).slice(0, 13);
}